<template>
  <AdminShell>
    <div class="head">
      <h2>Tenants</h2>
      <router-link to="/admin/tenants/new" class="btn">Create Tenant</router-link>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Slug</th>
          <th>Domain</th>
          <th>Widget Key</th>
          <th>Active</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="t in tenants" :key="t.id">
          <td>{{ t.name }}</td>
          <td>{{ t.slug }}</td>
          <td>{{ t.domain }}</td>
          <td>{{ t.widget_key }}</td>
          <td>{{ t.is_active ? "Yes" : "No" }}</td>
          <td>
            <router-link :to="`/admin/tenants/${t.id}/edit`">Edit</router-link>
          </td>
        </tr>
      </tbody>
    </table>
  </AdminShell>
</template>

<script setup>
import { ref, onMounted } from "vue";
import AdminShell from "@/components/admin/AdminShell.vue";
import { getTenants } from "@/services/admin";

const tenants = ref([]);

onMounted(async () => {
  const res = await getTenants();
  tenants.value = res.data?.tenants || [];
});
</script>

<style scoped>
.head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}
.btn {
  background: #8b5cf6;
  color: #fff;
  text-decoration: none;
  padding: 10px 14px;
  border-radius: 10px;
}
.table {
  width: 100%;
  background: white;
  border-collapse: collapse;
}
th, td {
  padding: 12px;
  border-bottom: 1px solid #eee;
  text-align: left;
}
</style>
